// extracted by mini-css-extract-plugin
export default {"navigationLinks":"NavigationLinks_navigationLinks__6rtzO","navLinks":"NavigationLinks_navLinks__105N1","active":"NavigationLinks_active__dQHxz"};